import { type Middleware } from '@nuxt/types'

export default <Middleware>function ({ store, $logger }) {
  $logger.initSessionReplay(store.state.user.username || '')
}
